import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconShareTab$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconShareTab extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'be432e67511c85780267f1eceee75ab6dd17e444', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'fc8fe9376b65f41f196ad591c81939cd3e783f47', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'dffd3e029317b605fd1f50384d15999479ed96a9', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.25 7H7.257a.5.5 0 0 1-.353-.853l3.742-3.742a.5.5 0 0 1 .708 0l3.742 3.742a.5.5 0 0 1-.354.854H11.75v5.495a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5zm4.25 2h2a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-1v7h9v-7h-1a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-share-tab", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-share-tab"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-share-tab":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconShareTab$1);
            }
            break;
    } });
}

const CosmosIconShareTab = CosmosIconShareTab$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconShareTab, defineCustomElement };
